import Vue from 'vue'
import AbstractSection from '@/models/sections/abstract'

export default Vue.extend({
  props: {
    item: {
      type: AbstractSection,
      required: true
    }
  }
})



// WEBPACK FOOTER //
// ./src/sections/abstract.js